module.exports = __webpack_public_path__ + "static/media/features-split-image-02.f0410a08.png";